/* mk-ritual-steps.js — split out of mk-sections.js; loaded only by the sections that render it. */
import { reduceMotion, onPageScroll, offPageScroll } from '@theme/mk-core';

/* ---- Ritual steps (sections/mk-ritual-steps.liquid) ---------------------- */
/* The hairline fills with the scroll, not on a timer: 0 as the row's top
   reaches 85% down the screen, full when it reaches 40%, so it always
   finishes while the section is still in view; scrolling back rewinds it.
   Each step lights (is-on) once the line reaches its dot. On phones the
   steps stack and the line is hidden, so each step lights when its own top
   passes 75% down the screen. Reduced motion: left complete (no data-live). */
class MkRitualSteps extends HTMLElement {
  connectedCallback() {
    if (reduceMotion.matches) return;
    this.steps = Array.from(this.querySelectorAll('.mk-rsteps__step'));
    if (!this.steps.length) return;
    this.phone = window.matchMedia('(max-width: 767px)');
    this.frame = 0;
    this.onScroll = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.update();
      });
    };
    this.dataset.live = '';
    onPageScroll(this.onScroll);
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    if (!this.onScroll) return;
    offPageScroll(this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    cancelAnimationFrame(this.frame);
  }

  update() {
    const vh = window.innerHeight;
    if (this.phone.matches) {
      this.steps.forEach((step) => step.classList.toggle('is-on', step.getBoundingClientRect().top < vh * 0.75));
      return;
    }
    const start = vh * 0.85;
    const end = vh * 0.4;
    const progress = Math.min(1, Math.max(0, (start - this.getBoundingClientRect().top) / (start - end)));
    this.style.setProperty('--mk-rs-p', progress.toFixed(4));
    const last = Math.max(1, this.steps.length - 1);
    this.steps.forEach((step, i) => step.classList.toggle('is-on', progress >= i / last - 0.001));
  }
}

customElements.get('mk-ritual-steps') || customElements.define('mk-ritual-steps', MkRitualSteps);
